import React, { createContext, useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import CryptoJS from "crypto-js";

// Create the AuthContext
export const AuthContext = createContext();

// AuthProvider Component
export const AuthProvider = ({ children }) => {
  const navigate = useNavigate();
  const [token, setToken] = useState(localStorage.getItem("token") || "");
  const [token_type, setToken_type] = useState(
    localStorage.getItem("token_type") || ""
  );
  const [isAuthenticated, setAuthenticated] = useState(!!token); // Initial authentication state

  // Function to verify the token
  const verifyUserToken = async () => {
    const publicRoutes = [
      "/ViewBooking",
      "/TermsAndConditions",
      "/LinkedInSignIn",
      "/ActivateAccount",
      "/PrivacyPolicy",
      "/web",
      "/ResetPassword",
      "/resetPassword",
    ];
    console.log("--AuthContext :: Verify User Token :: ", token_type);
    const isPublicRoute = publicRoutes.some((route) =>
      location.pathname.startsWith(route)
    );

    if (isPublicRoute) {
      return;
    }
    try {
      if (!token && window.location.pathname == "/SignUp") {
        console.log("--AuthContext :: -- no token found");
        localStorage.removeItem("token");
        localStorage.removeItem("token_type");
        return;
      }
      console.log("--AuthContext :: -- check in progress 1");
      if (!token) {
        console.log("--AuthContext :: -- no token found 2");
        localStorage.removeItem("token");
        localStorage.removeItem("token_type");
        setAuthenticated(false);
        // console.log(window.location.pathname,"window.location.pathname")
        if (
          window.location.pathname != "/SignIn" &&
          window.location.pathname != "/" &&
          window.location.pathname != "/showjob"
        ) {
          navigate("/SignIn");
        }
        return;
      }
      console.log("--AuthContext :: -- token type :: ", token_type);
      if (!token_type || token_type.length === 0) {
        console.log("--AuthContext :: -- token type check failed");
        localStorage.removeItem("token_type");
        setAuthenticated(false);
        if (
          window.location.pathname != "/SignIn" &&
          window.location.pathname != "/" &&
          window.location.pathname != "/showjob"
        ) {
          navigate("/SignIn");
        }
        return;
      }

      const serverURL = process.env.REACT_APP_SERVER_URL;
      const verifyTokenUrl = `${serverURL}/verifyToken`;

      const response = await fetch(verifyTokenUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          token: token,
        },
        body: JSON.stringify({ token }),
      });
      console.log("--AuthContext :: -- verification token api call");

      const data = await response.json();
      console.log(data, "auth data");
      if (data.status === "success") {
        console.log("User authenticated.");
        setAuthenticated(true);
        console.log(data, "Data");
        const encryptedMetadata = localStorage.getItem("metadata");
        console.log(encryptedMetadata, "encryptedMetadatai ");
        if (encryptedMetadata) {
          // && encryptedMetadata.data) {
          console.log(encryptedMetadata, "encryptedMetadata");
          const decryptedMetadata = JSON.parse(
            CryptoJS.AES.decrypt(
              encryptedMetadata,
              process.env.REACT_APP_SECRETKEY
            ).toString(CryptoJS.enc.Utf8)
          );
          if (
            !["/Adminapproval", "/Adminusage", "/Adminpricing"].includes(
              window.location.pathname
            ) &&
            decryptedMetadata.role_id === 99
          ) {
            navigate("/Adminapproval");
          }
          console.log(decryptedMetadata, "dmd", decryptedMetadata.cid);
          // if (decryptedMetadata.role_id === 1) {
          //   navigate("/AddCompany");
          // }
          // if (decryptedMetadata.role_id === 6) {
          //   navigate("/UserExperience");
          // }
          if (
            decryptedMetadata.role_id != 99 &&
            window.location.pathname !== "/AddCompany" &&
            (!decryptedMetadata?.cid ||
              decryptedMetadata?.cid == "" ||
              decryptedMetadata?.cid == null)
          ) {
            if (decryptedMetadata.role_id === 1) {
              navigate("/AddCompany");
            }
            if (decryptedMetadata.role_id === 6) {
              navigate("/UserExperience");
            }
          }
        }
        //setAuthenticated(true)
      } else {
        console.log("--AuthContext :: -- verification token api call failed");
        handleLogout();
      }
    } catch (error) {
      console.log("--AuthContext :: -- error verifying token :: ", error);
      handleLogout();
    }
  };

  // Logout function
  const handleLogout = () => {
    console.log("Logging out...");
    setToken("");
    setToken_type("");
    setAuthenticated(false);
    localStorage.removeItem("token");
    localStorage.removeItem("token_type");
    navigate("/SignIn");
  };

  // Sync token to localStorage on change
  useEffect(() => {
    if (token && (token_type === "Recuiter" || token_type === "")) {
      localStorage.setItem("token", token);
      localStorage.setItem("token_type", "Recuiter");
    } else {
      localStorage.removeItem("token");
      localStorage.removeItem("token_type");
    }
  }, [token, token_type]);

  return (
    <AuthContext.Provider
      value={{
        token,
        setToken,
        isAuthenticated,
        verifyUserToken,
        handleLogout,
        token_type,
        setToken_type,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

// Custom hook to use the AuthContext
export const useAuth = () => {
  return useContext(AuthContext);
};
